import { CciTab } from '@/features/events/components/Detail/Tabs/CciTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/events/event/$id/cci')({
  component: CciTab,
});
